<template>
  <div class="flex flex-row justify-between w-full">
    <EntityLookupNoForm
      v-if="entityToDisplay == null"
      name="entity"
      v-model:entity="entity"
      v-model:lookup-items="entities"
      label="Entity"
      size="w-1/2 mx-3 mt-2"
    ></EntityLookupNoForm>
    <StackedLabelDropdownNoForm
      v-if="entityToDisplay == null && contact"
      name="contactType"
      label="Contact Type"
      class="mx-3 mt-2 w-1/2!"
      options-label=""
      :options="options"
      v-model="selectedType"
    ></StackedLabelDropdownNoForm>
    <SubmitButton v-if="entityToDisplay == null && entity && entity.entityId" @click="submit" class="h-10 mt-auto w-36 mr-3"></SubmitButton>
  </div>
  <EntityDetail v-if="entity && entity.entityId" :entity="entity"></EntityDetail>
</template>

<script setup lang="ts">
import type { Entity } from "@/types/Entity";
import { getAllEntities } from "@/services/EntitiesService";
import { getContactRoleOptions, getProjectRoleFromDisplayText, getRoleDisplayText, ProjectRole } from "@/enums/ProjectRole";

const emit = defineEmits<{
  entitySelected: [entity: Entity];
  contactSelected: [entity: Entity, role: string];
}>();

interface Props {
  contact?: boolean;
  entityToDisplay?: Entity;
}
const props = withDefaults(defineProps<Props>(), {
  contact: false,
});

const entities = ref<Entity[]>([]);
const entity = ref<Entity>();

const options = ref<string[]>([]);

const selectedType = ref(getRoleDisplayText(ProjectRole.CONTACT));

const submit = (): void => {
  if (entity.value == null) return;

  if (props.contact) {
    const contactRole: ProjectRole | null = getProjectRoleFromDisplayText(selectedType.value);
    if (contactRole == null) {
      error("Error Occurred", "Invalid contact type selected");
    } else {
      emit("contactSelected", entity.value, selectedType.value.toUpperCase());
    }
  } else {
    emit("entitySelected", entity.value);
  }
};

onBeforeMount(async (): Promise<void> => {
  options.value = getContactRoleOptions();

  if (props.entityToDisplay != null) {
    entity.value = props.entityToDisplay;
  }

  getAllEntities().then((result: Entity[]) => {
    entities.value = result;
  });
});
</script>
